// src/components/auth/LogoutButton.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdLogout } from "react-icons/md";
import { useAuth } from "../../context/AuthContext";
import "./LogoutButton.css";

export default function LogoutButton() {
  const { signOut } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  const handleLogout = async () => {
    setBusy(true);
    setErr("");
    try {
      await signOut();
      navigate("/signin", { replace: true });
    } catch (e) {
      console.error("Logout error:", e);
      setErr("Failed to log out. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="logout-wrapper">
      <button
        className="profile-logout-btn"
        onClick={handleLogout}
        disabled={busy}
      >
        <MdLogout className="btn-icon" />
        {busy ? "Logging out…" : "Sair"}
      </button>

      {err && <div className="logout-error">{err}</div>}
    </div>
  );
}


